<template src='./ArrobaMedellinVerticalCard.html'></template>

<script>
export default {
  name: 'arroba-medellin-vertical-card',

  props: {
    img: { type: String },
    imgDescription: { type: String, default: "Imagen" },
    title: { type: String },
    subtitle: { type: String },
    body: { type: [String, Object], required: false },
    progress: { type: [Number, String]},
    typeCard: { type: Object },
    buttonText: { type: String },
    disableButton:{ type: Boolean },
    classButton: { type: String, required: false },
  },
  methods: {
    pushButton() {
      this.$emit('verticalCardClickButton')
    }
  },
  computed: {
    imgUrl() {
      return this.img ? this.img : 'https://storage.googleapis.com/arrobamedellin.appspot.com/Img_default.png';
    }
  }
}
</script>

<style lang="scss" scoped src="./ArrobaMedellinVerticalCard.scss"></style>
